import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import useFetchCauseCategories from '../../hooks/fetchCauseCategories';
import { message, Upload, Switch, Select, DatePicker, Form, Input } from 'antd';
import { LeftCircleOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import { app } from '../../config';
import moment from 'moment';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';

const { TextArea } = Input;
const Addcause = () => {
  const { t } = useTranslation(['common']);
  const [uploadObj, setUploadObj] = useState({});
  const [addUserResp, setAddUserResp] = useState({});
  const [show, setShow] = useState(false);
  const [uploadedImg, setUploadedImg] = useState('');
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [feeStatusToggle,setFeeStatusToggle] = useState(false)
  let user = JSON.parse(localStorage.getItem('user'));
  let navigate = useNavigate();
  window.onpopstate = () => {
    console.log('function called on popstate');
    navigate('/cause/view');
  };
  window.onhashchange = function () {
    //blah blah blah
    console.log('true');
  };
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };
  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      info.file ? setUploadedImg(info.file.response.data.Location) : ' ';
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  };
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
  const token = getTokenfromUserObj();
  const headers = { auth: token };
  const orgResp = useFetchOrganizations();
  const orgs = orgResp.response ? orgResp.response.data : [];
  console.log(orgs);
  const causeCatResp = useFetchCauseCategories();
  const causeCat = causeCatResp.response ? causeCatResp.response.data : [];
  console.log(causeCat);

  const uploadData = async (uploadObj) => {
    try {
      console.log(uploadObj);
      let addCauseAPI;
      // if(user.usetType==="A") addCauseAPI=`${app.URL}/cause/add`;
      // else if(user.usetType==="O") addCauseAPI=`${app.URL}/cause/add`;
      const res = await axios.post(`${app.URL}/cause/add`, uploadObj, { headers: { auth: token } });
      if (res.data.statusCode === 200) {
        setAddUserResp(res.data);
        setTimeout(() => {
          if (user.userType === 'A') navigate('/cause/view');
          else if (user.userType === 'O') navigate('/causes/view');
        }, 1000);
      }
    } catch (err) {
      console.log(err);
      setShow(false);
      if (err.response.status && err.response.data.statusCode) message.error(err.response.data.data);
    }
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onFinish = (values) => {
    console.log('Success:', values);
    setUploadObj({
      cause: values.causeName ? values.causeName : '',
      causeCategoryId: values.causeCategory ? values.causeCategory : '',
      organizationId: user.userType === 'A' && values.organization ? values.organization : user.organizationId,
      image: uploadedImg ? uploadedImg : '',
      validityDate: values.validityDate ? values.validityDate.format().split('T')[0] : '',
      isActive: values.isActive === true ? 1 : 0,
      isRecurring: values.isRecurring === true ? 1 : 0,
      displayPosition: values.displayPosition ? values.displayPosition : 1000,
      description: values.description ? values.description : '',
      feeQuestion:values.feeQuestion ? values.feeQuestion:null,
      feeQuestionStatus:values.feeQuestionStatus === true ? 1 : 0,
      serviceFee: values.serviceFee ? values.serviceFee : '',
      feeMessage: values.feeMessage ? values.feeMessage : '',
      feeStatus: values.feeStatus === true ? 1 : 0,
      createdByUserId: user.userId,
    });
    setShow(true);
  };
  console.log(user.organizationId);

  console.log(uploadObj);
  const submitData = () => {
    console.log('calling');
    if (Object.keys(uploadObj).length > 0) {
      uploadData(uploadObj);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  function goBack() {
    if (user.userType === 'A') navigate('/cause/view', { replace: true });
    else if (user.userType === 'O') navigate('/causes/view', { replace: true });
  }
  window.addEventListener('popstate', goBack);
  const c = useFetchCauseCategories();
  console.log(c);
  let causes = c ? c.response : [];
  console.log(causes);
  const renderList = []; //For testing purposes
  return (
    <div class='row mt-4 w-75 tbl'>
      <div class='row topbar ' style={{ height: '70px' }}>
        <div class='col-lg-4 fs-3 fw-bold'>
          {' '}
          <LeftCircleOutlined
            onClick={() => {
              if (user.userType === 'A') navigate('/cause/view', { replace: true });
              else if (user.userType === 'O') navigate('/causes/view', { replace: true });
            }}
            className='mt-3 ml-4 back-icon'
            style={{ fontSize: '38px' }}
          />
        </div>
        <div class='col-lg-7 fs-3 fw-bold '>
          <h2 class=' mb-5 mt-4 fw-bold text-white fs-4 ml-4'> {t('Add Cause')} </h2>
        </div>{' '}
      </div>
      <div class='col-lg-11 mb-5 mt-4 '>
        <div class='col-lg-9 align-self-center mt-2 mb-4'>
          <Form
            name='basic'
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 16,
            }}
            style={{
              maxWidth: 600,
            }}
            initialValues={{
              remember: true,
              ['id']: 1,
              ['causename']: 'Hammad',
              // ['causeCategory']: `${causeCat.length > 0 ? causeCat[0].cause_category : ''}`,
              ['isActive']: true,
              ['isRecurring']: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
          >
            {/* <Form.Item
label="Cause Id"
name="id"
defaultValue="1"
rules={[
  {
    required: false,
  },
]}
>
<Input />
</Form.Item> */}
            {user.userType === 'A' ? (
              <Form.Item
                colon={false}
                label='Organization'
                name='organization'
                rules={[
                  {
                    required: true,
                    message: 'Select Organization',
                  },
                ]}
              >
                <Select
                  listHeight={250}
                  listItemHeight={500}
                  placeholder='Select Organization'
                  style={{
                    width: 265,
                  }}
                >
                  {orgs.map((orgs) => {
                    return (
                      <Option key={orgs.organizationId} value={orgs.organizationId}>
                        {orgs.organizationName}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            ) : (
              ''
            )}
            <Form.Item
              colon={false}
              label='Cause Name'
              name='causeName'
              rules={[
                {
                  required: true,
                  message: 'Enter Cause',
                },
              ]}
            >
              <Input placeholder='Enter Cause' maxLength={20} />
            </Form.Item>
            <Form.Item
              colon={false}
              label='Cause Category'
              name='causeCategory'
              rules={[
                {
                  required: true,
                  message: 'Select Cause Category',
                },
              ]}
            >
              <Select
                listHeight={250}
                listItemHeight={500}
                placeholder='Select Cause Category'
                style={{
                  width: 265,
                }}
              >
                {causeCat.map((cause) => {
                  return (
                    <Option key={cause.causeCategoryId} value={cause.causeCategoryId}>
                      {cause.causeCategory}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>

            {/* Select box for organization */}

            <Form.Item
              colon={false}
              label='Valid Till'
              name='validityDate'
              rules={[
                {
                  required: true,
                  message: 'Please select date',
                },
              ]}
            >
              <DatePicker
                disabledDate={(current) => {
                  let customDate = moment().format('MM-DD-YYYY');
                  return current && current < moment(customDate, 'MM-DD-YYYY');
                }}
              />
            </Form.Item>
            <Form.Item label='Image' colon={false} name='image'>
              <Upload
                // name="avatar"
                listType='picture-card'
                className='avatar-uploader'
                showUploadList={false}
                action={`${app.URL}/upload/causeimage`}
                headers={headers}
                beforeUpload={beforeUpload}
                onChange={handleChange}
              >
                {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt='avatar'
                    style={{
                      width: '100%',
                    }}
                  />
                ) : (
                  uploadButton
                )}
              </Upload>
            </Form.Item >
            {/* Fee Status Fields */}
            <Form.Item label='Fee Status' colon={false} valuePropName='checked' name='feeStatus'>
              <Switch  onChange={(e)=>{setFeeStatusToggle(e)}} />
            </Form.Item>
            <Form.Item
              colon={false}
              label='Fee Message'
              name='feeMessage'
              rules={[
                {
                  message: 'Please enter fee message',
                },
              ]}
            >
              <TextArea placeholder='Enter fee message' disabled={!feeStatusToggle} maxLength={70} rows={4} />
            </Form.Item>
            <Form.Item
              colon={false}
              label='Fee %'
              name='serviceFee'
              rules={[
                {
                  required: false,
                  message: 'Enter fee %',
                },
              ]}
            >
              <Input placeholder='Enter fee %' min={1} type='number' disabled={!feeStatusToggle} maxLength={20} />
            </Form.Item>
            <Form.Item label='Donor Fee Option ' colon={false} valuePropName='checked' name='feeQuestionStatus'>
              <Switch disabled={!feeStatusToggle} />
            </Form.Item>
            <Form.Item
              colon={false}
              label='Donor Fee Option Message'
              name='feeQuestion'
              rules={[
                {
                  message: 'Please enter Donor fee option message',
                },
              ]}
            >
              <TextArea disabled={!feeStatusToggle} placeholder='Enter Donor fee option message' rows={4} />
            </Form.Item>
           
          
            
            <Form.Item
              colon={false}
              label='Display Position'
              name='displayPosition'
              rules={[
                {
                  required: false,
                  message: 'Enter display position',
                },
              ]}
            >
              <Input placeholder='Enter display position' min={1} type='number' maxLength={20} />
            </Form.Item>
            <Form.Item
              colon={false}
              label='Description'
              name='description'
              rules={[
                {
                  message: 'Please enter description',
                },
              ]}
            >
              <TextArea placeholder='Enter description' maxLength={70} rows={4} />
            </Form.Item>
            <Form.Item label='Recurring' colon={false} valuePropName='checked' name='isRecurring'>
              <Switch />
            </Form.Item>
            <Form.Item label='Active' colon={false} valuePropName='checked' name='isActive'>
              <Switch />
            </Form.Item>
            <Form.Item
              colon={false}
              wrapperCol={{
                offset: 8,
                span: 16,
              }}
            >
              {addUserResp.statusCode === 200 ? (
                <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title className='text-center'>Success</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>{addUserResp.message}</Modal.Body>
                  <Modal.Footer></Modal.Footer>
                </Modal>
              ) : addUserResp.statusCode === 400 ? (
                <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title className='text-center'>Failed</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>{addUserResp.data.message}</Modal.Body>
                  <Modal.Footer></Modal.Footer>
                </Modal>
              ) : (
                <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>Are you sure you want to add Cause?</Modal.Body>
                  <Modal.Footer>
                    <Button variant='secondary' onClick={handleClose}>
                      Cancel
                    </Button>
                    <Button variant='primary' htmlType='submit' onClick={submitData}>
                      Save Changes
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
              <button type='primary' class='btn btn-primary button' htmlType='submit'>
                Add
              </button>
              {/* <Button type="primary" htmlType="submit">
  Submit
</Button> */}
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Addcause;
